import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MpupInventoryViewComponent } from './componets/mpup-inventory-view/mpup-inventory-view.component'
import { RouterModule } from '@angular/router'
import { AuthGuard, ConfigModule } from '@spartacus/core'
import { MpupSharedModule } from '../mpup-shared/mpup-shared.module'
import { MbI18nModule } from '../../translations/mb-i18n.module'
import { PaginationModule, SpinnerModule } from '@spartacus/storefront'
import { ReactiveFormsModule } from '@angular/forms'
import { MpupInventoryListItemComponent } from './componets/mpup-inventory-list-item/mpup-inventory-list-item.component'
import { MpupAmountCircleComponent } from './componets/mpup-amount-circle/mpup-amount-circle.component'

@NgModule({
  declarations: [MpupInventoryViewComponent, MpupInventoryListItemComponent, MpupAmountCircleComponent],
  imports: [
    CommonModule,
    MpupSharedModule,
    MbI18nModule,
    PaginationModule,
    ReactiveFormsModule,
    RouterModule.forChild([{
      path: null as any,
      canActivate: [AuthGuard],
      component: MpupInventoryViewComponent,
      data: {
        cxRoute: 'inventory'
      }
    }]),
    ConfigModule.withConfig({
      cmsComponents: {
        MACSPickUpPointComponent: {
          component: MpupInventoryViewComponent,
        }
      }
    }),
    SpinnerModule,
  ],
})
export class MpupInventoryModule { }
